package pl.zar.tikthrow.shared.dto

import kotlinx.serialization.Serializable

/**
 * Structural error model for the versioned API (card #13; extended by T108).
 *
 * Every 4xx/5xx response from `/api/v1` is serialised as this object: no raw
 * stack traces, no internal identifiers in [message].
 */
@Serializable
data class ApiError(
    val code: String,
    val message: String,
    val details: Map<String, String>? = null
)
